 /* eslint-disable no-unused-vars */
import React, { memo, useState } from "react";
import { Card, Button, Col, Row, Form, Modal, Input } from "antd";
import { useLocation, useNavigate } from "react-router";
import CustomTable from "../../../components/CustomTable";
import messageToast from "../../../components/messageToast/messageToast";
import apis from "../../../api/stateAPI";

const OrlpcclaimapparmForm = () => {
  const { state } = useLocation();
  const [form] = Form.useForm();
  const [reason, setReason] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [selected, updateSelected] = useState([]);
  const [fileLists, setFileLists] = useState({});
  const [reqAmt, setReqAmt] = useState({});

  const navigate = useNavigate();

  const cancelNavigation = () => setShowModel(false);
  const confirmNavigation = () => navigate("/orlpcclaimappgm");

  const dateToYMD = (date) => {
    const strArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const d = date.getDate();
    const m = strArray[date.getMonth()];
    const y = date.getFullYear();
    return `${d <= 9 ? "0" + d : d}-${m}-${y}`;
  };

  const url = process.env.REACT_APP_API_BASE_URL.replace("api/", "");
  const data =
    state?.expense_data?.length > 0
      ? state.expense_data.map((e) => {
          // const unixtime = new Date(e.expense_date);
          // const time = dateToYMD(unixtime);
          return {
            ...e,
            S_No: e.id,
            Expense_Date: e.expense_date,
            Expense_Type: e.expense_type,
            Request_Amount: e?.amount,
            Reason: e?.remark,
            Bill_Copy: e?.bill_copy
              ? JSON.parse(e?.bill_copy)
                  ?.map((item) => `${url}public/storage/app/public/tickets/${item}`)
                  .join(", ")
              : "-",
          };
        })
      : [];

  const handleViewClick = (rowInfo) => navigate("/orlpcclaimappgmForm", { state: rowInfo });

  const SelectedAll = () => {
    if (state && state.expense_data) {
      updateSelected([...state.expense_data.map((_) => _.id)]);
    }
  };

  const handleApprovel = () => {
    const expenseIds = state?.expense_data?.map((item) => item.id) || [];
    const imageName = fileLists ? Object.values(fileLists).flat().map((file) => file.name) : [];

    // Fix: Sending approved_expense_amount as an object with expense_id as keys
    const approvedExpenseAmount = {};
    expenseIds.forEach((id) => {
      if (reqAmt[id] !== undefined) {
        approvedExpenseAmount[id] = reqAmt[id];
      }
    });

    const data = {
      id: state?.id,
      expense_id: expenseIds,
      approved_expense_amount: approvedExpenseAmount, // Fixed structure
      bill_copy: imageName,
      status: state?.ticketstatus === "Waiting @ BO Payment Release" ? "Waiting @ BO Approval" : "Waiting @ BO Payment Release",
    };

    apis.updatePettyCashRequestData(data).then((res) => {
      if (res.data?.status === 200) {
        messageToast({
          message: res?.data?.statusText,
          status: res?.data?.status,
          title: "Payment Request",
        });
        navigate(state?.ticketstatus === "Waiting @ Back Office" ? "/orlpcclaimappbo" : "/orlpcclaimappgm");
      }
    });
  };

  const handleReject = () => {
    if (reason) {
      const data = {
        id: state?.id,
        status: state?.ticketstatus === "Waiting @ Back Office" ? "Waiting @ ARM" : "GM Rejected",
        rejected_reason: reason,
        rejected_by: state?.ticketstatus === "Waiting @ Back Office" ? "Back Office" : "GM",
      };
      apis.updatePettyCashRequestData(data).then((res) => {
        if (res.data?.status === 200) {
          messageToast({ message: res?.data?.statusText, status: res?.data?.status, title: "Payment Request" });
          navigate(state?.ticketstatus === "Waiting @ Back Office" ? "/orlpcclaimappbo" : "/orlpcclaimappgm");
        }
      });
    } else {
      messageToast({ message: "Please Enter the Reason", status: 400, title: "Payment Request" });
    }
  };

  const columns = [
    { key: "1", headerName: "S.No", field: "S_No", hide: false, width: 70 },
    { key: "2", headerName: "Expense Date", field: "Expense_Date", hide: false, width: 200 },
    { key: "3", headerName: "Expense Type", field: "Expense_Type", hide: false, width: 180 },
    { key: "4", headerName: "Reason", field: "Reason", hide: false, width: 250 },
    { key: "5", headerName: "Requested Amount", field: "Request_Amount", hide: false, width: 200 },
    {
      key: "6",
      headerName: "Approved Expense Amount",
      field: "spend_amounts",
      hide: false,
      width: 200,
      renderCell: (params) => (
        <Input
          type="number"
          name="approved_expense_amount"
          value={reqAmt[params?.row?.id] || ""}
          onChange={(e) => {
            setReqAmt((prev) => ({
              ...prev,
              [params?.row?.id]: e.target.value, // Fix: Use row id instead of index
            }));
          }}
        />
      ),
    },
  ];

  return (
    <>
      <div className="h-screen apphide lasthide">
        <Card>
          <Row>
            <Col span={24}>
              <Form form={form} autoComplete="off">
                <Row gutter={[15, 0]}></Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <CustomTable
          showHeader={false}
          showEdit={false}
          dataSource={data}
          column={columns}
          hideActionBtn={true}
          handleViewClick={handleViewClick}
          title={"Approval List"}
        />
        {state?.ticketstatus !== "Waiting @ AH Approval" && (
          <Col span={12} style={{ textAlign: "center" }} className="d-flex align-items-center justify-content-end mt-3">
            <Form.Item className="mx-2">
              <Button className="orangeFactory" type="primary" htmlType="submit" onClick={handleApprovel}>
                Approved
              </Button>
            </Form.Item>
            <Form.Item>
              <Button onClick={() => setShowModel(true)}>Reject</Button>
            </Form.Item>
          </Col>
        )}
      </div>

      <Modal open={showModel} width="40%" onOk={handleReject} okButtonProps={{ danger: true }} onCancel={cancelNavigation} title={<span className="text-2xl text-red-600">Reject Reason?</span>}>
        <div className="text-justify">
          <span>Please provide the reason for rejecting the request</span>
        </div>
        <textarea placeholder="Please Provide Reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={5} className="w-full mt-4" />
      </Modal>
    </>
  );
};

export default memo(OrlpcclaimapparmForm);
